import { DatasetTablesControllerApi, GetTableListResponse } from '../../../api/generated'
import { useCallback, useEffect, useState } from 'react'
import TABLES_MOCK from '../mocks/tables.mock.json'

export const apiClient = new DatasetTablesControllerApi()

export const useDatasetTables = (datasetId: string) => {
  const [data, setData] = useState<GetTableListResponse['tables']>([])
  const [loading, setLoading] = useState<boolean>(false)
  const [error, setError] = useState<Error | string | null>(null)

  const fetchDatasetVersions = useCallback(async () => {
    setLoading(true)
    setError(null)

    try {
      const delay = 1000 * Math.floor(Math.random() * 4) + 1
      const mock: GetTableListResponse = await new Promise(resolve => setTimeout(resolve, delay, TABLES_MOCK))

      if (mock) return setData(mock?.tables)

      const response = await apiClient.getDatasetTableListRaw({ datasetId })
      const jsonData = await response.value()
      setData(jsonData?.tables || [])
    } catch (err: unknown) {
      setError((err as Error)?.message || 'An unknown error occurred')
    } finally {
      setLoading(false)
    }
  }, [datasetId])

  useEffect(() => {
    fetchDatasetVersions()
  }, [])

  return { data, loading, error, refetch: fetchDatasetVersions }
}
